module.exports = __webpack_public_path__ + "static/img/7965_phase_function_Paper_Points.8daba3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7965_phase_function_Paper_Points.png
// module id = D8Rj
// module chunks = 0